import { FlexBox } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { AppointmentProposal } from '../../data-access/appointmentProposals';
import ROUTE_PATHS from '../../routes/paths';
import EndServiceCallButton from './Buttons/EndServiceCallButton';

interface ActionsSectionProps {
  proposal: AppointmentProposal;
}

const ActionsSection: React.FC<ActionsSectionProps> = ({ proposal }) => (
  <FlexBox flexDirection={'column'} px={2} gap={2}>
    <Button
      color={'softGold'}
      size={'large'}
      component={Link}
      to={ROUTE_PATHS.APPOINTMENT_PATH({
        appointmentId: proposal.appointmentId,
        appointmentProposalId: proposal.appointmentProposalId,
        path: 'sync-status',
      })}
    >
      Service Titan Estimate Sync Status
    </Button>
    <EndServiceCallButton proposal={proposal} />
  </FlexBox>
);

export default ActionsSection;
